import React from 'react';
import { DeviceIconProps, getSizeInPixels } from '../types';

/**
 * Curtain Icon Style 02 - Curtains (Material Symbol)
 * Curtains-style icon
 * - isOn = true (open): 青綠色
 * - isOn = false (closed): 灰色
 * 
 * @see https://fonts.google.com/icons?selected=Material+Symbols+Outlined:curtains
 */
export const Style02_Curtains: React.FC<DeviceIconProps> = ({ 
  isOn = false, 
  size = 'small',
  className = '',
}) => {
  const pixelSize = getSizeInPixels(size);
  const colorClass = isOn ? 'text-teal-500' : 'text-slate-400';

  return (
    <span 
      className={`material-symbols-outlined ${colorClass} ${className}`}
      style={{ 
        fontSize: `${pixelSize}px`,
        fontVariationSettings: `'FILL' ${isOn ? 1 : 0}, 'wght' 400, 'GRAD' 0, 'opsz' 24`
      }}
    >
      curtains
    </span>
  );
};

export default Style02_Curtains;
